/**
 * 主商品sku
 */
import * as React from 'react'
import ProductInquery from './product-inquery';
import ProductGoods from './product-goods';
import OtherInfo from './other-info';


export default function LayoutSku ( props: any ) {
    const { productIsMarketGoods } = props;
    
    if (productIsMarketGoods) {
      return <>
      <OtherInfo {...props} type="goods"/>
      <ProductGoods {...props} type="goods"/>
    </>
   }else{

     return <ProductInquery {...props} type="inquery"/>
   }
}
